import { useState } from "react"
import { Link } from "react-router-dom";
import { BASE_URL } from '../apiConfig';
import { Sparkles , Pin, PinOff  } from "lucide-react";
import OrderModal from '../cors/OrderModal'; 
import { useAuth } from "../context/AuthProvider";
import { toast } from 'sonner';

export default function ProductCard({ product, getStatusColor, fetchProducts, newProducts, pinnedproducts }) {
  const { token } = useAuth();
  const [imageError, setImageError] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenOrder, setIsModalOpenOrder] = useState(false); 
  const [isPinned, setIsPinned] = useState(
    (pinnedproducts || []).includes(product.id)
  );
  
  const isNewProduct = (newProducts || []).some(newProd => newProd.id === product.id);

   const togglePin = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/pin-products`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ product_id: product.id })
      });

      const data = await res.json();
      if (res.ok) {
        if (data.status === "pinned") {
          toast.success("Produit épinglé");
          setIsPinned(true);
        } else {
          toast.success("Produit désépinglé");
          setIsPinned(false);
        }
        fetchProducts();
      } else {
        toast.error("Erreur lors du pin/unpin");
      }
    } catch (err) {
      toast.error("Erreur réseau");
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("fr", {
      style: "currency",
      currency: "MAD",
    }).format(price)
  }

  return (
    <div className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:-translate-y-2">
      <Link to={`/products/${product.id}`}>
        <div className="relative cursor-pointer overflow-hidden rounded-t-3xl ">
        <div className="aspect-square relative bg-gradient-to-br from-[var(--color-primary-50)] via-white to-gray-100">
          {!imageError && product.image_py ? (
            <img
              src={`${BASE_URL}/storage/${product.image_py}`}
              alt={product.name}
              fill
              className="object-cover h-full w-full transition-transform duration-700 group-hover:scale-110"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <svg className="h-16 w-16 text-[var(--color-primary-100)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                />
              </svg>
            </div>
          )}
        </div>

        { product.status !== "active"  && (
          <div className="absolute top-5 left-[-40px] bg-red-500 text-white text-[10px] font-bold px-10 py-1 rotate-[-45deg] shadow-md">
            غير متوفر حاليا
          </div>
        )}

        <div className="absolute top-3 right-3 flex place-items-end gap-1">
          {product.product_expired_soon === true && (
            <span className="bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full text-[9px] font-semibold shadow-md">
              STOCK LIMITE
            </span>
          )}

          <span className={`px-2 pt-[3px] pb-0.5 rounded-full  text-[9px] max-w-max font-semibold shadow-md ${getStatusColor(product.status)}`}>
            {product.status.replace(/_/g, " ").toUpperCase()}
          </span>
          { isPinned ? <Pin size={20} className="font-bold text-[var(--color-primary-500)] rotate-30"/> : "" }
        </div>
          {isNewProduct && (
            <span className="absolute flex gap-0.5 items-center top-9 right-3 bg-green-500 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-full shadow-md">
              <Sparkles size={12} />
              Nouveau
            </span>
          )}
      </div>
      </Link>

      {/* Content */}
      <div className="px-4 pt-2 pb-4 max-lg:pb-3">
        <div className="flex justify-between items-center">
          <span className="text-[11px] max-lg:text-[10px] text-gray-500 font-medium">{product.category?.title?.substring(0, 20)}{product.category?.title.length > 20 ? '...' : ''}</span>
          <div>
            {[...Array(5)].map((_, i) => (
            <span key={i} className={i < product.rating ? 'text-yellow-500 text-lg max-lg:text-sm' : 'text-gray-300 text-lg max-lg:text-sm'}>
              ★
            </span>
          ))}
          </div>
        </div>

        <h3 className="font-bold max-lg:text-[13px] text-gray-900 mb-1 max-lg:mb-0 line-clamp-2 group-hover:text-[var(--color-primary-500)] transition-colors duration-300 line-clamp-2">
          {product.name?.substring(0, 25)}{product.name?.length > 30 ? '...' : ''}
        </h3>

        {product.description ? <p className="text-gray-600 text-xs max-lg:text-[9px] mb-2 max-lg:mb-0 line-clamp-2">{product.description?.substring(0, 30)}{product.description?.length > 20 ? '...' : '' }</p> 
        : <p className="h-6 max-lg:h-3"></p>}

        {/* Pricing */}
        <div className="mb-4 max-lg:mb-1.5">
          <div className="flex items-center justify-between">
            <div>
              <span className="text-xl max-lg:text-xs font-bold text-[var(--color-primary-500)]">{formatPrice(product.price.saller_price)}</span>
              <div className="text-[11px] max-lg:text-[9px] text-gray-500">Recommandé a vente : <span className="font-bold">{formatPrice(product.price.selling_price)}</span></div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-2">
              <button
                onClick={() => setIsModalOpenOrder(true)} 
                className={`flex-1 border px-2 py-2 rounded-xl font-semibold text-lg max-lg:py-[5px] max-lg:text-[10px] transition-colors duration-200 focus:outline-none text-xs
                  ${product.status === 'active' && (product.price?.stock || 0) > 0
                    ? 'border-[var(--color-primary-500)] text-[var(--color-primary-500)] hover:bg-[var(--color-primary-500)] hover:text-white cursor-pointer'
                    : 'border-gray-300 text-gray-400 bg-gray-200 cursor-not-allowed'}
                `}
                disabled={(product.status !== 'active') || (product.price?.stock || 0) <= 0}
              >
                {product.status === 'active' && (product.price?.stock || 0) > 0 ? 'Commandez' : 'Out of Stock'}
              </button>
              <button 
              onClick={()=>{ togglePin() }}
              className="border px-2 rounded-xl transition-colors duration-200 focus:outline-none border-[var(--color-primary-500)] text-[var(--color-primary-500)] hover:bg-[var(--color-primary-500)] hover:text-white cursor-pointer">
                  { !isPinned ? <Pin className="w-3.5 h-3.5 max-lg:w-3 max-lg:h-3" /> : <PinOff className="w-3.5 h-3.5 max-lg:w-3 max-lg:h-3" /> }
              </button>
        </div>
      </div>
      
      {
        isModalOpenOrder &&
          <OrderModal
            isOpen={isModalOpenOrder}
            onClose={() => setIsModalOpenOrder(false)}
            product={product}
          />
      }
    </div>
  )
}
